import hyperdom from 'hyperdom'
import assetPath from './assetPath.js'
import formatDepositPrice from './packages/ui-helpers/formatDepositPrice.js'


export default function (config, currency, deposit) {
  const head = config.styleCode === 'CH' && deposit && `Only ${formatDepositPrice({currency, amount: deposit.paymentAmount})} deposit to book`

  return hyperdom.viewComponent({
    onload () {
      this.showBanner = document.cookie.indexOf('covidConfidence=false') === -1
      this.showHiddenFeatures = false
    },

    renderMoreInfoLink (){
      return (
        <div class='book-with-confidence-banner__more-info' onclick={() => {
          if (config.isMobile) {
            this.showHiddenFeatures = !this.showHiddenFeatures
          }
        }}>
        </div>
      )},

    render () {
      if (!this.showBanner) return null
      return <div class='book-with-confidence'>
        <div class='book-with-confidence-banner__inner'>
          <span id='book-with-confidence-banner_close-btn' class='book-with-confidence-banner__close' onclick={() => {
            this.showBanner = false
            document.cookie = 'covidConfidence=false;path=/;'
          }}></span>
          {config.bookWithConfidence.items && config.bookWithConfidence.items.length > 0
            ? <div class='book-with-confidence-banner__features book-with-confidence-banner__desktop'>
              {config.bookWithConfidence.items.map(item => <div class='tooltip'>
                <span><img src={assetPath(`public/img/${config.styleCode}/book-with-confidence/${item.icon}.svg`)} alt='' /></span>
                <div class='tooltip__content'>
                  <h4 class='tooltip__header'>{item.icon === 'deposit'?`${head}`: item.head}</h4>
                  <p>{item.body}</p>
                </div>
              </div>
              )}
            </div>
            : undefined
          }
          {this.renderMoreInfoLink()}
        </div>
        {config.isMobile && this.showHiddenFeatures
          ? <div class='book-with-confidence-banner__features book-with-confidence-banner__features--mobile banner-dropdown'>
            {config.bookWithConfidence.items.map(item => <div class='book-with-confidence-banner__features--mobile__feature'>
              <span><img src={assetPath(`public/img/${config.styleCode}/book-with-confidence/${item.icon}.svg`)} alt='' /></span>
              <div class='book-with-confidence-banner__features--mobile__content'>
                <h4>{item.icon === 'deposit'?`${head}`: item.head}</h4>
                <p>{item.body}</p>
              </div>
            </div>
            )}
            <div class='book-with-confidence-banner__features--mobile__hide'><a class='book-with-confidence-banner__more-info-link' href='' id='book-with-confidence-banner_hide-btn' onclick={(e) => {
              e.preventDefault()
              this.showHiddenFeatures=false
            }}>Hide</a></div>
          </div>
          : null}
      </div>
    },
  })
}
